import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  StyledHTML,
} from '@rulebooks/evidend-titan';
import type { ButtonVariant } from '@rulebooks/evidend-titan/dist/types/components/Button/Button';
import type { ModalProps } from '@rulebooks/evidend-titan/dist/types/components/Modal/Modal';
import { Trans } from '@lingui/macro';
import React, { useCallback, useState } from 'react';

interface ConfirmModalProps {
  cancelButtonLabel?: React.ReactNode;
  children: React.ReactNode;
  confirmButtonLabel?: React.ReactNode;
  confirmButtonTestId?: string;
  confirmButtonVariant: ButtonVariant;
  isShown: boolean;
  onCancel: () => any;
  onConfirm: () => any;
  title: string;
  size?: ModalProps['size'];
}

export const ConfirmModal = ({
  cancelButtonLabel,
  children,
  confirmButtonLabel,
  confirmButtonTestId,
  confirmButtonVariant = 'primary',
  isShown = false,
  onCancel,
  onConfirm,
  title,
  size = 'm',
}: ConfirmModalProps) => {
  const [isConfirming, setConfirming] = useState<boolean>(false);

  const confirm = useCallback(async () => {
    setConfirming(true);
    await onConfirm();
    setConfirming(false);
  }, [onConfirm, setConfirming]);

  const cancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <Modal isCloseable={!isConfirming} isShown={isShown} size={size} zIndex={2000} onClose={cancel}>
      <ModalHeader title={title} />
      <ModalContent>
        <StyledHTML>
          <p>{children}</p>
        </StyledHTML>
      </ModalContent>
      <ModalActions>
        <Button isDisabled={isConfirming} variant="clear" onClick={cancel}>
          {cancelButtonLabel || <Trans>Annuleren</Trans>}
        </Button>
        <Button
          isDisabled={isConfirming}
          testId={confirmButtonTestId}
          variant={confirmButtonVariant}
          onClick={confirm}
        >
          {confirmButtonLabel || <Trans>Bevestigen</Trans>}
        </Button>
      </ModalActions>
    </Modal>
  );
};
